import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "spinner"]

  declare readonly iconTarget: HTMLElement
  declare readonly hasIconTarget: boolean
  declare readonly spinnerTarget: HTMLElement
  declare readonly hasSpinnerTarget: boolean

  start(event: Event) {
    const button = this.element as HTMLButtonElement
    const form = button.closest("form")
    
    // Check if the form is valid before proceeding
    // If invalid, we return and let the browser's native validation take over
    if (form && !form.checkValidity()) {
      return
    }

    // If the button is already disabled or we are already loading, do nothing
    if (button.disabled || button.dataset.loading === "true") return

    // Mark as loading to prevent multiple clicks
    button.dataset.loading = "true"

    // Show spinner, hide icon
    if (this.hasIconTarget) this.iconTarget.classList.add("hidden")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    
    // Add loading styles
    button.classList.add("opacity-70", "cursor-not-allowed")
    
    // We disable the button after a tiny delay to ensure the form submission 
    // is initiated by the browser if requestSubmit fails for some reason
    // but requestSubmit is the preferred way.
    if (form) {
      event.preventDefault()
      button.disabled = true
      form.requestSubmit()
    }
  }
}
